<luigi-container
  [viewurl]="url"
  id="advisor-chat"
  class="advisor"
  webcomponent='{"tagName": "sap-advisor-chat"}'
  host="dcp"
  [context]="context">
</luigi-container>
